<script setup lang="ts">
import { ScrollAreaCorner, ScrollAreaRoot, type ScrollAreaRootProps, ScrollAreaViewport } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'
import ScrollBar from './ScrollBar.vue'
import { cn } from '@/components/utils'

const props = defineProps<
  ScrollAreaRootProps & { class?: HTMLAttributes['class']; direction?: 'horizontal' | 'vertical' }
>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <ScrollAreaRoot v-bind="delegatedProps" :class="cn('relative overflow-hidden', props.class)">
    <ScrollAreaViewport class="h-full w-full relative rounded-[inherit]">
      <slot />
    </ScrollAreaViewport>
    <ScrollBar :orientation="props.direction" />
    <ScrollAreaCorner />
  </ScrollAreaRoot>
</template>
